import { MapPin, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const ROUTE_IMAGE = "/photos/couple-safa.webp";

const Place = ({ name, highlight = false }) => (
    <div className="flex flex-col items-center gap-2 text-center">
        <span
            className="flex h-11 w-11 items-center justify-center rounded-full"
            style={{
                border: "1.5px solid rgba(232,180,184,0.7)",
                color: highlight ? "var(--gold)" : "var(--rose)",
                background: highlight ? "rgba(212,175,55,0.12)" : "transparent",
            }}
        >
            <MapPin size={18} />
        </span>
        <div>
            <p className="font-display text-xl leading-snug sm:text-2xl" style={{ color: "var(--ivory)" }}>
                {name}
            </p>
            <p className="mt-1 text-xs uppercase tracking-[0.25em]" style={{ color: "var(--rose)" }}>
                Bilara Town
            </p>
        </div>
    </div>
);

export default function BaraatJourney() {
    return (
        <section
            id="baraat"
            data-testid="baraat-section"
            style={{ background: "linear-gradient(160deg, #8A3B4E 0%, #702C3D 100%)" }}
        >
            <div className="mx-auto max-w-3xl px-6 py-20 text-center sm:py-28">
                <Reveal>
                    <p className="eyebrow" style={{ color: "var(--rose)" }}>
                        03 · The grand arrival
                    </p>
                    <h2
                        className="font-display mt-6 text-2xl leading-relaxed tracking-tight sm:text-3xl"
                        style={{ color: "var(--ivory)" }}
                    >
                        On 24 November, Dileep and his baraat leave{" "}
                        <span className="italic" style={{ color: "var(--gold)" }}>Bera Lakhelav</span> at 12:00 PM, bound
                        for <span className="italic" style={{ color: "var(--gold)" }}>Bera Hambro Ki Bawri</span>, where
                        Vijju and the Hambad family await with open hearts.
                    </h2>
                    <p
                        className="mt-6 inline-block rounded-full px-5 py-2 text-xs font-semibold uppercase tracking-[0.2em]"
                        style={{ border: "1px solid rgba(212,175,55,0.5)", color: "var(--gold)" }}
                        data-testid="baraat-datetime"
                    >
                        24 November 2026 · 12:00 PM
                    </p>
                </Reveal>

                <Reveal delay={0.15}>
                    <div className="my-10 h-px" style={{ background: "rgba(212,175,55,0.35)" }} />
                    <div className="flex items-start justify-center gap-6 sm:gap-12" data-testid="baraat-route-card">
                        <Place name="Bera Lakhelav" />
                        <span className="pt-3" style={{ color: "var(--gold)" }}>
                            <ArrowRight size={20} />
                        </span>
                        <Place name="Bera Hambro Ki Bawri" highlight />
                    </div>
                    <div className="my-10 h-px" style={{ background: "rgba(212,175,55,0.35)" }} />
                </Reveal>

                <Reveal delay={0.25}>
                    <div className="arch-frame mx-auto max-w-sm" style={{ borderColor: "rgba(212,175,55,0.6)" }}>
                        <img
                            src={ROUTE_IMAGE}
                            alt="Vijay Laxmi and Dileep celebrating together"
                            data-testid="baraat-image"
                            className="h-[340px] w-full object-cover sm:h-[420px]"
                        />
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
